module.exports = "<footer class=\"main-footer\">\n  <!-- To the right -->\n  <div class=\"pull-right hidden-xs\">\n    Compostela, Nayarit\n  </div>\n  <!-- Default to the left -->\n  <strong>Copyright &copy; 2018 Puerta Del Cielo.</strong> Todos los derechos reservados.\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/isai/funeraria/src/app/views/page-sections/footerweb.html
// module id = ../../../../../src/app/views/page-sections/footerweb.html
// module chunks = main